<template>
  <div v-bind:class="{'spinner-is-visible': isSpinnerVisible }">
    <div v-bind:class="['entity-details', {'hidden': !isLoaded }]">
      <section>
        <header>
          <div>
            <div>{{ fulcrumApp.label }}</div>
            <div v-if="fulcrumApp.name && fulcrumApp.name !== fulcrumApp.label" class="note">{{ fulcrumApp.name }}</div>
            <div v-if="fulcrumApp.dashboardType" class="label-info mt-2">{{ fulcrumApp.dashboardType }}</div>
          </div>
        </header>
        <div 
          v-if="fulcrumApp.dashboardGroups"
          class="entity-detail form-group" 
        >
          <label class="placeholder placeholder-static">Dashboard Groups</label>
          <div 
            v-for="(group, index) in fulcrumApp.dashboardGroups" 
            :key="index"
            class="mt-1 mb-2"
          >
            <span class="label label-undefined text-size-small" style="font-weight: normal;"><span class="text-color-dark">{{ index + 1 }}</span></span>
            <span class="label label-active text-size-small ms-2" style="text-transform: capitalize; font-weight: normal;">{{ group.label }}</span>
          </div>
        </div>
      </section>

      <div class="entity-details-actions">
        <div>
          <a
            :href="'/project_dashboards/' + fulcrumApp.id"
            title="Dashboard"
            class="btn-expandable btn-expandable-preview btn-expandable-sm"
          >
            <span class="icon" data-icon="fullscreen"></span>
            <span>View</span>
          </a>
        </div>
        <div
          v-if="userCanUpdate"
        >
          <a
            :href="'/project_dashboards/' + fulcrumApp.id + '/edit'"
            title="Edit"
            class="btn-expandable btn-expandable-edit btn-expandable-sm"
          >
            <span class="icon" data-icon="edit"></span>
            <span>Edit</span>
          </a>
        </div>
      </div>
    </div>
    <div class="spinner"></div>
  </div>
</template>

<script>
import helpers from "../../helpers.js";

import EntityDetails from "../shared/details/entity_details";

export default {
  extends: EntityDetails,

  components: {

  },

  setup () {
    return {
      h$: helpers
    }
  },

  data() {
    return {
      fulcrumApp: {
        fields: [],
        statusField: {},
        dashboardType: '',
        dashboardGroups: []
      }
    }
  },

  watch: {
    entityId: function() {
      this.fetchDetails()
    }
  },

  computed: {
    
  },

  mounted: function() {
    this.fetchDetails()
  },

  methods: {
    fetchDetails: function() {
      this.isSpinnerVisible = true;

      app.graphql.get(
        "details.fulcrumApp",

        {
          filter: {
            formId: this.entityId
          }
        },

        (data) => {
          this.isLoaded = true

          this.fulcrumApp = data.data.fulcrumApps.edges[0].node;

          this.fulcrumApp.statusField = JSON.parse(this.fulcrumApp.statusField) || {};
          this.fulcrumApp.fields = this.fulcrumApp.fields.map((field) => {return JSON.parse(field) });

          this.fulcrumApp.dashboardType = this.fulcrumApp.dashboardType ? this.fulcrumApp.dashboardType.replace(/_/g, ' ') : 'N/A';

          this.fulcrumApp.dashboardGroups = this.fulcrumApp.dashboardGroups.map(name => {
            const field = this.fulcrumApp.fields.find(item => item.data_name === name);
            
            return field ? { 'data_name': name, 'label': field.label } : { 'data_name': name, 'label': name };
          });

          setTimeout(() => {
            this.isSpinnerVisible = false
          }, 500)
        },

        (error) => {
          app.ui.toast.add({
            priority: "danger",
            title : "Project Dashboard Details",
            message : "Something went wrong! Project Dashboard cannot be found or doesn't exist!"
          })
        }
      );
    }
  }
}

</script>
